import AccordionContent from './AccordionContent';
import AccordionHeader from './AccordionHeader';
import AccordionWrapper from './AccordionWrapper';
export var Accordion = {
  Wrapper: AccordionWrapper,
  Header: AccordionHeader,
  Content: AccordionContent
};